import { useQuery } from "@tanstack/react-query";

import type { UUID } from "@/core/types";

import { getPatientConsents } from "../queryFunctions/getPatientConsents";
import { patientConsentsKeys } from "../keyFactory";

export function usePatientConsents(patientId: UUID) {
  return useQuery({
    enabled: !!patientId,
    queryFn: () => getPatientConsents(patientId),
    queryKey: patientConsentsKeys.list(patientId),
    refetchOnWindowFocus: true,
  });
}
